import { jobLists } from "character";
import FormComponents from "components/forms/FormComponents";
import JobIcon from "components/job-icon/JobIcon";
import Link from "components/link/Link";
import NoCharacter from "components/no-character/NoCharacter";
import RelicCheckbox from "components/relic-checkbox/RelicCheckbox";
import { items } from "data-files/items";
import { quests } from "data-files/quests";
import { EorzeaDataType, GameData, InputType, LinkType, RelicData, View } from "enums";
import manager from "managers/app";
import { ViewRelicInfo } from "managers/types/relic-types";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import utils from "util/utils";
import ContentHeader from "views/page-parts/content/content-header/ContentHeader";
import DetailsSection from "views/page-parts/content/details-section/DetailsSection";
import Obtained from "views/page-parts/content/obtained/Obtained";
import OverviewTable from "views/page-parts/content/overview-table/OverviewTable";
import { Requirement } from "views/page-parts/content/relic-requirements/types";
import { ViewToolSplendorousVrandticVisionarysProps } from "views/relics/tools/splendorous/vrandtic-visionarys/types";
import { TaskInfo } from "views/type";
import "./ToolSplendorousVrandticVisionarys.css";

const mapStateToProps = (state:AppState) => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		userInfo: state.userInfo,
		hideCompletedSteps: state.userInfo.options.hideCompletedSteps,
		hideCompletedTasks: state.userInfo.options.hideCompletedTasks,
		showMaximumItemQty: state.userInfo.options.showMaximumItemQty,
		showJob: state.userInfo.options.job,
	};
};

class ToolSplendorousVrandticVisionarys extends Component<ViewToolSplendorousVrandticVisionarysProps> {
	private requirements:Requirement[] = [];
	private importantNPCs:GameData.NPC[] = [];
	private relicInfo:ViewRelicInfo = {
		jobs: jobLists.relic[RelicData.Group.TOOL_SPLENDOROUS],
		type: RelicData.Type.TOOL,
		relic: RelicData.Group.TOOL_SPLENDOROUS,
		part: RelicData.Part.TOOL_VRANDTIC_VISIONARYS,
		steps: [RelicData.Step.INSPIRATIONAL_COMPONENT],
		stepPlaceholders: { [RelicData.Step.INSPIRATIONAL_COMPONENT]: { ITEM: "Inspirational Components" } },
		next: {
			part: RelicData.Part.TOOL_LODESTAR,
			view: View.RELIC_TOOLS_SPLENDOROUS_LODESTAR,
		},
		previous: {
			part: RelicData.Part.TOOL_BRILLIANT,
			view: View.RELIC_TOOLS_SPLENDOROUS_BRILLIANT,
		},
	};

	constructor(props:ViewToolSplendorousVrandticVisionarysProps){
		super(props);
		this.requirements = this.getRequirements();
		this.importantNPCs = this.getImportantNPCs();
	}

	render():JSX.Element{
		const character = manager.data.getActiveCharacter();
		if(character === null){ return <NoCharacter />; }

		const completeSteps = manager.content.getCompleteSteps(character.progress, this.relicInfo);

		let row = "odd-row";

		return (
			<div id="tool-splendorous-vrandticvisionarys" className="relic">
				<ContentHeader requirements={this.requirements} importantNPCs={this.importantNPCs} relicInfo={this.relicInfo}>
					<p>{t.t("Complete")}<Link type={LinkType.LODESTONE} lodestoneType={EorzeaDataType.BLUEQUEST} text={GameData.Quest.TOOL_FOR_THE_AGES} lodestoneID={quests[GameData.Quest.TOOL_FOR_THE_AGES].lodestoneID} /></p>
				</ContentHeader>
				<div id="relic-checklist">
					<OverviewTable character={character} completeSteps={completeSteps} relicInfo={this.relicInfo} />
				</div>
				<div id="relic-details">
					<h1>{t.t("Details")}</h1>
					{this.props.hideCompletedSteps && completeSteps.allComplete ? t.t("All Steps Complete") : null }
					<DetailsSection title={RelicData.Step.INSPIRATIONAL_COMPONENT} placeholders={this.relicInfo.stepPlaceholders[RelicData.Step.INSPIRATIONAL_COMPONENT]} id={RelicData.Step.INSPIRATIONAL_COMPONENT} stepComplete={completeSteps[RelicData.Step.INSPIRATIONAL_COMPONENT]}>
						<div className="table-wrapper">
							<table className="table">
								<thead><tr><th>{t.t("Job")}</th><th>{t.t("Task")}</th><th>{t.t("Found")}</th><th>{t.t("Quantity")}</th><th>{t.t("Inventory")}</th><th>{t.t("To Obtain")}</th><th>{t.t("Done")}</th></tr></thead>
								<tbody>
									{
										this.relicInfo.jobs.map((job) => {
											if(this.props.showJob !== null && this.props.showJob !== job){ return null; }

											const stepComplete = character.progress.isComplete(this.relicInfo.type, this.relicInfo.relic, this.relicInfo.part, RelicData.Step.INSPIRATIONAL_COMPONENT, job);
											if(this.props.hideCompletedSteps && stepComplete){ return null; }

											const taskInfo:TaskInfo[] = [{
												task: RelicData.Task.TASK_1,
												complete: character.progress.isComplete(this.relicInfo.type, this.relicInfo.relic, this.relicInfo.part, RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_1, job),
												target: manager.relics.getTaskItem(RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_1, job),
											}];

											if(jobLists.type.gatherer.includes(job)){
												taskInfo.push({ task: RelicData.Task.TASK_2, complete: character.progress.isComplete(this.relicInfo.type, this.relicInfo.relic, this.relicInfo.part, RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_2, job), target: manager.relics.getTaskItem(RelicData.Step.INSPIRATIONAL_COMPONENT, RelicData.Task.TASK_2, job) });
											}

											const tableRows = taskInfo.map((thisTask, taskIndex) => {
												if(this.props.hideCompletedTasks && thisTask.complete){ return null; }

												let thisTarget = GameData.Item.UNKNOWN;
												if(utils.guards.isEnumValue(GameData.Item, thisTask.target)){ thisTarget = thisTask.target; }

												const inventory = manager.data.getInventoryStatus({
													item: thisTarget,
													relic: [this.relicInfo.type, this.relicInfo.relic, this.relicInfo.part, RelicData.Step.INSPIRATIONAL_COMPONENT, thisTask.task],
													job: job,
													getMax: this.props.showMaximumItemQty,
												});

												const showJobIcon = manager.content.shouldShowJobIcon(this.props.hideCompletedTasks, taskInfo, taskIndex);
												const rowSpan = manager.content.getRowSpan(this.props.hideCompletedTasks, taskInfo, taskIndex);

												return <tr key={`${job}-${RelicData.Step.INSPIRATIONAL_COMPONENT}-${thisTask.task}`} className={row}>
													{showJobIcon ? <td rowSpan={rowSpan}><JobIcon job={job} /></td> : null}
													<td>{t.t(thisTarget)}</td>
													<td><Obtained obtained={items[thisTarget].obtained} qtyNeeded={inventory.total} /></td>
													<td>{inventory.qtyPerJob.toLocaleString()}</td>
													<td><FormComponents.TextInput label={{ hide: true }} input={{ type: InputType.NUMBER, value: inventory.inventory, dataAttributes: { item: thisTarget }, events: { onChange: manager.content.inventoryUpdated }}} /></td>
													<td>{inventory.toObtain.toLocaleString()}</td>
													<td><RelicCheckbox character={character} job={job} relicInfo={this.relicInfo} step={RelicData.Step.INSPIRATIONAL_COMPONENT} task={thisTask.task} /></td>
												</tr>;
											});

											row = row === "odd-row" ? "even-row" : "odd-row";
											return tableRows;
										})
									}
									{
										completeSteps[RelicData.Step.INSPIRATIONAL_COMPONENT]
											? <tr className="all-complete"><td colSpan={7}><p>{t.t("All Complete")}</p></td></tr>
											: null
									}
								</tbody>
							</table>
						</div>
					</DetailsSection>
				</div>
			</div>
		);
	}

	componentDidMount(){
		manager.view.changeComplete();
	}

	private getRequirements():Requirement[]{
		if(!this.relicInfo || this.relicInfo.previous === null){ return []; }
		return [
			{ type: "previous part", part: this.relicInfo.previous.part, partView: this.relicInfo.previous.view },
		];
	}

	private getImportantNPCs():GameData.NPC[]{
		return [];
	}
}
export default connect(mapStateToProps)(ToolSplendorousVrandticVisionarys);
